var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5Sal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#767674;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,77.3c-4.8,0-8.9-1-12.2-3c-3.3-2-6-5.1-8.1-9.2L40.3,60c0.7,2.4,1.9,4.4,3.4,5.9 c1.6,1.5,3.8,2.2,6.8,2.2c2.1,0,3.8-0.4,5.2-1.1c1.4-0.7,2.6-1.8,3.4-3.2c0.8-1.4,1.2-3.1,1.2-5.1c0-2-0.4-3.7-1.1-5 c-0.7-1.4-1.8-2.4-3.2-3.1c-1.4-0.7-3.1-1-5.2-1c-1.4,0-2.8,0.1-4,0.4c-1.2,0.3-2.4,0.7-3.4,1.3c-1,0.6-1.9,1.3-2.7,2.3l-9-1.7 l3.4-30.5h33.2v9.3H43.8l-1.7,13.4l-0.2,1.1H42c1.2-1.3,2.8-2.4,4.8-3.1c2-0.7,4.3-1.1,7-1.1c3.6,0,6.7,0.7,9.2,2.2 c2.6,1.4,4.5,3.5,5.9,6c1.4,2.6,2.1,5.5,2.1,8.9c0,3.2-0.5,6-1.6,8.4c-1.1,2.4-2.5,4.4-4.5,6c-1.9,1.6-4.1,2.8-6.6,3.6 C55.9,76.9,53.2,77.3,50.3,77.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Sal);
export default __webpack_public_path__ + "static/media/5sal.557ba12f3f18b09e7a3c7e391e82073a.svg";
export { ForwardRef as ReactComponent };